/**
 * Audit log API on the IAM gateway (`/audit-log/api/audit-logs`, …).
 * See {@link iamBackendUrl} in `src/config/backend.ts`.
 */
import { iamBackendUrl } from './backend';
/** Build audit log API URL. */
export function auditLogApiUrl(pathFromSlash) {
    const rel = pathFromSlash.startsWith('/') ? pathFromSlash : `/${pathFromSlash}`;
    return iamBackendUrl(rel);
}
